export const UPDATE_SELECTED_VEHICLE = 'myCarDealer/UPDATE_SELECTED_VEHICLE';
export const UPDATE_SELECTED_DEALER = 'myCarDealer/UPDATE_SELECTED_DEALER';
export const UPDATE_PRIMARY_VEHICLE = 'myCarDealer/UPDATE_PRIMARY_VEHICLE';
export const UPDATE_SELECTED_VEHICLE_ADDITIONAL_DATA = 'myCarDealer/UPDATE_SELECTED_VEHICLE_ADDITIONAL_DATA';
export const UPDATE_DEALER_DETAILS = 'myCarDealer/UPDATE_DEALER_DETAILS';